import type { FaireProductEntity } from "../../entity_types/product";

export const p_rp9dmj3fjv: FaireProductEntity = {
  token: "p_rp9dmj3fjv",
  type: "product",
  name: "Eclipse Brass Candle Holder",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/a0a572eb81ecb71748327f281f8f300c219199bc249652b5dd56b41931215732.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/67d83c5dcae813fe066193a758a57ea4a4f363d4a82410fce300bc8dcc33746d.jpeg",
    "https://cdn.faire.com/fastly/27ab4e75a600836b35745079920f122b52322ab965406e750fc7a414bcf5da8f.jpeg",
    "https://cdn.faire.com/fastly/f63873ce7fbc5b41abf45060e1ff3e438a83e5edb025edc6293145cbb215eb4f.jpeg",
    "https://cdn.faire.com/fastly/c9182bc31cf081805f21d55e02fc229be5953243f9b109c161aedbdd020a8fda.jpeg",
  ],
  priceDollars: 29,
  description:
    "Eclipse candle holders are a striking minimalist design crafted from solid brass giving the product weight and substance.\n\nThe wide disc frames the candle, while creating an illusion of floating above a table surface.",
  tags: [],
  msrpDollars: 58,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:24.079Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
